import { Action } from 'store/store';
import { MyPortfolioCapsulesDataState } from 'widgets/myPortfolioCapsules/store/data/MyPortfolioCapsulesDataState';

export enum MyPortfolioCapsulesDataActionType {
    SET = 'SET_MY_PORTFOLIO_CAPSULES_DATA',
    CLEAR = 'CLEAR_MY_PORTFOLIO_CAPSULES_DATA',
}

export type MyPortfolioCapsulesDataSetAction = Action<
    MyPortfolioCapsulesDataActionType.SET,
    MyPortfolioCapsulesDataState
>;

export const myPortfolioCapsulesDataSetAction = (
    data: MyPortfolioCapsulesDataState
): MyPortfolioCapsulesDataSetAction => ({
    type: MyPortfolioCapsulesDataActionType.SET,
    payload: data,
});

export type MyPortfolioCapsulesDataClearAction =
    Action<MyPortfolioCapsulesDataActionType.CLEAR>;

export const myPortfolioCapsulesClearAction =
    (): MyPortfolioCapsulesDataClearAction => ({
        type: MyPortfolioCapsulesDataActionType.CLEAR,
    });

export type MyPortfolioCapsulesDataAction =
    | MyPortfolioCapsulesDataSetAction
    | MyPortfolioCapsulesDataClearAction;
